// @ts-nocheck
import { Card, Form } from "react-bootstrap";
import UploadSectionAnalysis from "./UploadSectionAnalysis";
import { FaEye } from "react-icons/fa";
import { FaChevronRight, FaChevronDown } from "react-icons/fa";
import AnalysisField from "../../AnalysisFields/AnalysisField";
import { useState, useEffect, useMemo } from "react";
import "./AnalysisTab.css";
import History from "../../ComponentsAnalysis/HistoryAdequacao/History";
import type { TabDocumentoItem } from "../../../../../types";

interface EvolucaoItem {
  anoReferencia?: number;
  valor?: number;
  quantidade?: number;
  quantidadeAssociados?: number;
  receita?: number;
  [key: string]: unknown;
}

interface CampoResposta {
  idCampo?: string;
  idCampoJson?: string;
  tipoCampo?: string;
  titulo?: string;
  descricao?: string;
  resposta?: string | number;
  nomeArquivo?: string;
  alternativa?: { valor?: string; titulo?: string }[];
  [key: string]: unknown;
}

const renderRespostaCampo = (
  campo: CampoResposta,
  idx: string | number,
  nivel = 0,
  arquivos: { nomeArquivo?: string; identificador?: string; dataUpload?: string }[] = [],
  associadosDadosAPI: EvolucaoItem[] = [],
  salarioMinimoAnoAnterior: number | string | undefined,
  analysisValues: Record<string, { resposta?: string; valor?: number; historico?: unknown }>,
  associadoAnoAtual: Record<string, { resposta?: string; receita?: string }>,
  handleAnalysisChange: (id: string, valores: unknown) => void,
  anoBase: number,
  receitaOperacionalDadosAPI: EvolucaoItem[] = [],
  tema?: string,
) => {
  const formatCNPJ = (cnpj: string) => {
    if (!cnpj || cnpj.length !== 14) return cnpj;
    return cnpj.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      "$1.$2.$3/$4-$5",
    );
  };

  const tipo = campo.tipoCampo ?? "";
  const receitaOperacional: EvolucaoItem[] = receitaOperacionalDadosAPI || [];

  const renderDescricao = () => (
    <div className="mb-2">
      {campo.titulo && <div className="fw-semibold">{campo.titulo}</div>}
      {campo.descricao && (
        <div className="text-muted small">{campo.descricao}</div>
      )}
    </div>
  );

  const indentStyle = { marginLeft: `${nivel * 24}px` };

  if (campo.titulo === "Receita Operacional") {
    const receitaAnoAnterior = receitaOperacional?.[0]?.valor ?? 0;

    const receitaFormatada = Number(receitaAnoAnterior || 0).toLocaleString(
      "pt-BR",
      { style: "currency", currency: "BRL" },
    );

    if (campo.tipoCampo === "decimal") {
      return (
        <Form.Group key={idx} className="mt-2" style={indentStyle}>
          {renderDescricao()}
          <Form.Control
            type="text"
            value={receitaFormatada}
            disabled
            className="bg-light small-input"
          />
        </Form.Group>
      );
    }
  }

  if (campo.idCampo === "DRE-receita-operacional") {
    const receitaAnoAnterior = receitaOperacional?.[0]?.valor ?? 0;

    const receitaFormatada = Number(receitaAnoAnterior || 0).toLocaleString(
      "pt-BR",
      { style: "currency", currency: "BRL" },
    );

    return (
      <Form.Group key={idx} className="mt-2" style={indentStyle}>
        {renderDescricao()}
        <Form.Control
          type="text"
          value={receitaFormatada}
          disabled
          className="bg-light small-input"
        />
      </Form.Group>
    );
  }

  if (campo.titulo === "Salário mín. ano anterior") {
    const salarioMinimoFormatado = (
      Number(salarioMinimoAnoAnterior) || 0
    ).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });

    return (
      <Form.Group key={idx} className="mt-2" style={indentStyle}>
        {renderDescricao()}
        <Form.Control
          type="text"
          value={salarioMinimoFormatado}
          disabled
          className="bg-light small-input"
        />
      </Form.Group>
    );
  }

  if (campo.titulo === "12 salários mínimos") {
    const dozeSalarioMinimoFormatado = (
      (Number(salarioMinimoAnoAnterior) || 0) * 12
    ).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });

    return (
      <Form.Group key={idx} className="mt-2" style={indentStyle}>
        {renderDescricao()}
        <Form.Control
          type="text"
          value={dozeSalarioMinimoFormatado}
          disabled
          className="bg-light small-input"
        />
      </Form.Group>
    );
  }

  if (campo.titulo === "RO > 12 salários mín") {
    let respostaCampo = "NÃO";

    const dozeSalarioMinimo = (Number(salarioMinimoAnoAnterior) || 0) * 12;
    const receitaAnoAnterior = receitaOperacional?.[0]?.valor ?? 0;

    if (Number(receitaAnoAnterior || 0) > Number(dozeSalarioMinimo || 0)) {
      respostaCampo = "SIM";
    }

    return (
      <div key={idx} className="mt-2">
        <Form.Label className="fw-semibold" style={{ color: "#6c757d" }}>
          {campo.titulo}
        </Form.Label>
        <div>
          <button
            type="button"
            disabled
            className="btn small-input w-100"
            style={{
              backgroundColor: respostaCampo === "NÃO" ? "red" : "blue",
              color: "white",
              borderColor: respostaCampo === "NÃO" ? "red" : "blue",
            }}
          >
            {respostaCampo}
          </button>
        </div>
      </div>
    );
  }

  if (tema === "7. EVOLUÇÃO RECEITA OPERACIONAL") {
    const lista = receitaOperacionalDadosAPI || [];

    if (
      campo.tipoCampo === "decimal" &&
      String(campo.titulo) === String(lista?.[1]?.anoReferencia)
    ) {
      const valor = lista?.[1]?.valor ?? 0;
      const receitaFormatada = Number(valor || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });

      return (
        <div key={idx} className="mt-2">
          <Form.Label className="fw-semibold" style={{ color: "#6c757d" }}>
            {campo.titulo}
          </Form.Label>
          <Form.Control
            type="text"
            value={receitaFormatada}
            disabled
            className="bg-light small-input"
          />
        </div>
      );
    }

    if (
      campo.tipoCampo === "decimal" &&
      String(campo.titulo) === String(lista?.[0]?.anoReferencia)
    ) {
      const valor = lista?.[0]?.valor ?? 0;
      const receitaFormatada = Number(valor || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });

      return (
        <div key={idx} className="mt-2">
          <Form.Label className="fw-semibold" style={{ color: "#6c757d" }}>
            {campo.titulo}
          </Form.Label>
          <Form.Control
            type="text"
            value={receitaFormatada}
            disabled
            className="bg-light small-input"
            id={tema}
          />
        </div>
      );
    }

    if (campo.tipoCampo === "decimal" && campo.titulo === "% Evolução") {
      const v1 = Number(lista?.[1]?.valor ?? 0);
      const v2 = Number(lista?.[0]?.valor ?? 0);

      let resultado;
      if (v1 === 0 && v2 > 0) resultado = "100.00";
      else if (v1 === 0 && v2 === 0) resultado = "0.00";
      else if (v1 > 0 && v2 === 0) resultado = "0.00";
      else resultado = ((v2 / v1 - 1) * 100).toFixed(2);

      return (
        <div key={idx} className="mt-2">
          <Form.Label className="fw-semibold" style={{ color: "#6c757d" }}>
            {campo.titulo}
          </Form.Label>
          <Form.Control
            type="text"
            value={`${resultado}%`}
            disabled
            className="bg-light small-input"
          />
        </div>
      );
    }
  }


  if (
    tema === "8. 80% DE RETENÇÃO DE ASSOCIADOS" ||
    tema === "9. EVOLUÇÃO DO ASSOCIATIVISMO"
  ) {
    const associados = associadosDadosAPI || [];

    if (campo.tipoCampo === "text" && (String(campo.titulo) === "2023" || Number(campo.titulo) === 2023)) {
      const label01 = associados?.[1]?.anoReferencia;
      const valorLabel01 = associados?.[1]?.quantidade;

      return (
        <div key={idx} className="mt-2">
          <Form.Label className="fw-semibold" style={{ color: "#6c757d" }}>
            {label01}
          </Form.Label>
          <Form.Control
            type="text"
            value={`${valorLabel01 ?? ""}`}
            disabled
            className="bg-light small-input"
          />
        </div>
      );
    }

    if (campo.tipoCampo === "text" && (String(campo.titulo) === "2024" || Number(campo.titulo) === 2024)) {
      const idCampo = "anoAtualMenosUm";
      const label02 = associados?.[0]?.anoReferencia;
      const valorLabel02 = associados?.[0]?.quantidade;

      const handleChange = (e) => {
        const novoValor = e.target.value;
        handleAnalysisChange(idCampo, { resposta: novoValor });
      };

      return (
        <div key={idx} className="mt-2">
          <Form.Label className="fw-semibold" style={{ color: "#6c757d" }}>
            {label02}
          </Form.Label>
          <Form.Control
            type="text"
            value={
              analysisValues?.[idCampo]?.resposta ??
              (valorLabel02 ?? "").toString()
            }
            onChange={handleChange}
            className="small-input"
          />
        </div>
      );
    }

    if (campo.titulo === "% Retenção") {
      const a1 = Number(associados?.[1]?.quantidade ?? 0);
      const a2 = Number(associados?.[0]?.quantidade ?? 0);

      let resultado;
      if (a1 === 0 && a2 > 0) resultado = "0.00";
      else if (a1 === 0 && a2 === 0) resultado = "0.00";
      else if (a1 > 0 && a2 === 0) resultado = "0.00";
      else resultado = ((a2 / a1) * 100).toFixed(2);

      return (
        <div key={idx} className="mt-2">
          <Form.Label className="fw-semibold" style={{ color: "#6c757d" }}>
            {campo.titulo}
          </Form.Label>
          <Form.Control
            type="text"
            value={`${resultado}%`}
            disabled
            className="bg-light small-input"
          />
        </div>
      );
    }

    if (campo.titulo === "% Evolução") {
      const a1 = Number(associados?.[1]?.quantidade ?? 0);
      const a2 = Number(associados?.[0]?.quantidade ?? 0);

      let resultado;
      if (a1 === 0 && a2 > 0) resultado = "100.00";
      else if (a1 === 0 && a2 === 0) resultado = "0.00";
      else if (a1 > 0 && a2 === 0) resultado = "0.00";
      else resultado = ((a2 / a1 - 1) * 100).toFixed(2);

      return (
        <div key={idx} className="mt-2">
          <Form.Label className="fw-semibold" style={{ color: "#6c757d" }}>
            {campo.titulo}
          </Form.Label>
          <Form.Control
            type="text"
            value={`${resultado}%`}
            disabled
            className="bg-light small-input"
          />
        </div>
      );
    }
  }


  if (["pdf", "upload", "xlsx"].includes(tipo)) {
    const nomeEsperado = (campo.nomeArquivo ?? "").toLowerCase();
    const arquivosDoCampo = (arquivos || []).filter((arquivo) =>
      (arquivo.nomeArquivo ?? "").toLowerCase().includes(nomeEsperado),
    );

    return (
      <Form.Group key={idx} className="mt-2" style={indentStyle}>
        {renderDescricao()}
        <UploadSectionAnalysis arquivosDiretos={arquivosDoCampo} />
      </Form.Group>
    );
  }


  if (tipo === "radio") {
    return (
      <Form.Group key={idx} className="mt-2" style={indentStyle}>
        {renderDescricao()}
        {campo.alternativa?.map((alt, i) => {
          const altExt = alt as { valor?: string; titulo?: string; campo?: CampoResposta[] };
          const label = altExt.valor || altExt.titulo;
          const isChecked = campo.resposta === label || String(campo.resposta) === label;

          return (
            <div key={`${idx}-alt-${i}`} className="mb-2">
              <Form.Check
                type="radio"
                label={label}
                checked={!!isChecked}
                disabled
              />
              {isChecked &&
                altExt.campo?.map((subCampo, subIdx) =>
                  renderRespostaCampo(
                    subCampo,
                    `${idx}-alt-${i}-sub-${subIdx}`,
                    nivel + 1,
                    arquivos,
                    associadosDadosAPI,
                    salarioMinimoAnoAnterior,
                    analysisValues,
                    associadoAnoAtual,
                    handleAnalysisChange,
                    anoBase,
                    receitaOperacionalDadosAPI,
                    tema,
                  ),
                )}
            </div>
          );
        })}
      </Form.Group>
    );
  }


  if (["decimal", "input", "text"].includes(tipo)) {
    const valor =
      campo.titulo?.toLowerCase().includes("cnpj") ||
        campo.idCampo?.toLowerCase().includes("cnpj")
        ? formatCNPJ(String(campo.resposta ?? ""))
        : String(campo.resposta ?? "");

    return (
      <div key={idx} className="mt-2" style={indentStyle}>
        {renderDescricao()}
        <Form.Control
          type="text"
          value={valor}
          disabled
          className="bg-light small-input"
        />
      </div>
    );
  }

  if (tipo === "textarea") {
    return (
      <div key={idx} className="mt-2" style={indentStyle}>
        {renderDescricao()}
        <Form.Control
          as="textarea"
          rows={3}
          value={campo.resposta || ""}
          disabled
          className="bg-light"
        />
      </div>
    );
  }

  return null;
};

export interface TopicAnalysisProps {
  data: TabDocumentoItem;
  resposta?: unknown;
  uploadedFiles?: Record<string, unknown>;
  analysisValues?: Record<string, unknown>;
  onAnalysisChange?: (idCampo: string, novosValores: unknown) => void;
  associadosDadosAPI?: unknown;
  salarioMinimoAnoAnterior?: unknown;
  errosAnalise?: Record<string, unknown>;
  evolucaoReceitaOperacional?: unknown;
  evolucaoAssociados?: unknown;
  isOpen?: boolean;
  onToggle?: () => void;
  apto?: boolean;
  analiseBloqueada?: boolean;
}

const TopicAnalysis = ({
  data,
  uploadedFiles,
  analysisValues = {},
  onAnalysisChange,
  associadosDadosAPI,
  salarioMinimoAnoAnterior,
  errosAnalise = {},
  evolucaoReceitaOperacional,
  evolucaoAssociados,
  isOpen = false,
  onToggle,
  analiseBloqueada = false,
}: TopicAnalysisProps) => {
  const [associadosAnoAtualMenosUm, setAssociadoAnoAtualMenosUm] = useState<Record<string, { resposta?: string; receita?: string }>>({});

  const analysisValuesTyped = analysisValues as Record<string, { dataInicio?: string;[key: string]: unknown }> | undefined;
  const dataInicioStr = typeof analysisValuesTyped?.dataInicio === "string" ? analysisValuesTyped.dataInicio : undefined;
  const anoBase = dataInicioStr
    ? new Date(dataInicioStr).getFullYear()
    : new Date().getFullYear();

  const associadosArray = useMemo(
    () => (Array.isArray(associadosDadosAPI) ? associadosDadosAPI : []) as EvolucaoItem[],
    [associadosDadosAPI],
  );
  const evolucaoReceita = (Array.isArray(evolucaoReceitaOperacional) ? evolucaoReceitaOperacional : []) as EvolucaoItem[];
  const evolucaoAssoc = (Array.isArray(evolucaoAssociados) ? evolucaoAssociados : []) as EvolucaoItem[];

  useEffect(() => {
    if (!associadosArray.length) return;

    const valoresIniciais: Record<string, { resposta?: string; receita?: string }> = {};
    const anoAtual = new Date().getFullYear();

    (data?.criterios ?? []).forEach((criterio: unknown) => {
      const c = criterio as { campo?: { idCampoJson?: string; resposta?: string }[] };
      c.campo?.forEach((campo) => {
        if (campo.idCampoJson) {
          valoresIniciais[campo.idCampoJson] = {
            resposta: campo.resposta || "",
          };
        }
      });
    });

    const dadosAnoAtualMenosUm = associadosArray.find(
      (item) => item.anoReferencia === anoAtual - 1,
    );

    valoresIniciais["anoAtualMenosUm"] = {
      resposta: String(dadosAnoAtualMenosUm?.quantidadeAssociados ?? dadosAnoAtualMenosUm?.quantidade ?? ""),
      receita: String(dadosAnoAtualMenosUm?.receita ?? ""),
    };

    setAssociadoAnoAtualMenosUm(valoresIniciais);
  }, [data, associadosArray]);

  const handleAnalysisChange = (idCampo, novosValores) => {
    if (analiseBloqueada) return;
    const chave = idCampo || "campoIndefinido";
    const valorAnterior = analysisValues?.[chave] || {};

    const payload =
      typeof novosValores === "string" || typeof novosValores === "number"
        ? { resposta: novosValores }
        : novosValores || {};

    if (onAnalysisChange) {
      onAnalysisChange(chave, {
        ...valorAnterior,
        ...payload,
      });
    }

    if (
      ["anoAtualMenosUm", "anoAtual"].includes(idCampo) &&
      payload?.resposta !== undefined &&
      payload?.resposta !== ""
    ) {
      const valorNumerico = parseInt(payload.resposta, 10);
      if (
        !isNaN(valorNumerico) &&
        typeof window.setQuantidadeAssociadosGlobal === "function"
      ) {
        window.setQuantidadeAssociadosGlobal(valorNumerico);
      }
    }
  };

  const valorCampo = analysisValues?.[data.idCampoJson] as { historico?: Record<string, unknown> } | undefined;
  const historico = valorCampo?.historico || {};

  const deveMostrarHistorico =
    !!historico?.solicitadoEm ||
    !!historico?.adequadoEm ||
    historico?.adequacaoRealizada === true;

  const teveAdequacaoRealizada =
    historico?.adequacaoRealizada === true ||
    (!!historico?.adequadoEm && historico?.adequadoEm !== "");

  const titulosSomenteAnalista = [
    "6. RECEITA OPERACIONAL ANUAL / ARRECADAÇÃO MÍNIMA MENSAL",
    "7. EVOLUÇÃO RECEITA OPERACIONAL",
    "8. 80% DE RETENÇÃO DE ASSOCIADOS",
    "9. EVOLUÇÃO DO ASSOCIATIVISMO",
  ];

  return (
    <Card className="mb-4">
      <Card.Body>
        <button
          type="button"
          onClick={onToggle}
          className="w-100 d-flex justify-content-between align-items-center"
          style={{
            background: "transparent",
            border: "none",
            padding: 0,
            textAlign: "left",
          }}
          aria-expanded={isOpen}
        >
          <div className="d-flex align-items-center gap-2">
            {isOpen ? (
              <FaChevronDown style={{ color: "#212529" }} />
            ) : (
              <FaChevronRight style={{ color: "#212529" }} />
            )}

            <Card.Title
              className="fw-semibold mb-0"
              style={{ color: "#212529", fontSize: "1rem" }}
            >
              {data.title}
            </Card.Title>
          </div>

          {data.link ? (
            <a
              href={data.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary text-decoration-none d-flex align-items-center gap-2"
              onClick={(e) => e.stopPropagation()}
            >
              <FaEye /> Ver modelo
            </a>
          ) : (
            <span />
          )}
        </button>

        {isOpen && (
          <>
            {data.description && (
              <Card.Text className="mt-2">{data.description}</Card.Text>
            )}

            {(data.criterios ?? [])
              .filter((criterio: unknown) => {
                const c = criterio as { campo?: { idCampo?: string; resposta?: string }[] };
                const camposAssociado = c.campo?.filter((campo) =>
                  campo.idCampo?.startsWith("associado-"),
                );
                if (camposAssociado?.length) {
                  return camposAssociado.some((campo) =>
                    campo.resposta?.toString().trim(),
                  );
                }
                return true;
              })
              .map((criterio: unknown, idx: number) => {
                const c = criterio as { titulo?: string; campo?: CampoResposta[] };
                return (
                  <div key={idx} className="mb-4 mt-3">
                    {c.titulo && (
                      <Form.Label className="fw-semibold">
                        {c.titulo}
                      </Form.Label>
                    )}

                    {c.campo?.map((campo, i) => {
                      const campoKey = `${idx}-${i}`;
                      return (
                        <div key={campoKey}>
                          {renderRespostaCampo(
                            campo as CampoResposta,
                            campoKey,
                            0,
                            (data.arquivos ?? []) as { nomeArquivo?: string; identificador?: string; dataUpload?: string }[],
                            evolucaoAssoc,
                            salarioMinimoAnoAnterior as number | string | undefined,
                            analysisValues as Record<string, { resposta?: string; valor?: number; historico?: unknown }>,
                            associadosAnoAtualMenosUm,
                            handleAnalysisChange,
                            anoBase,
                            evolucaoReceita,
                            data.title,
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              })}

            {deveMostrarHistorico && (
              <>
                <History
                  idCampo={data.idCampoJson}
                  initialValue={historico}
                  onChange={handleAnalysisChange}
                  isSindicato={false}
                />

                {teveAdequacaoRealizada ||
                  titulosSomenteAnalista.includes(data.title) ? (
                  <AnalysisField
                    idCampo={data.idCampoJson}
                    initialValue={analysisValues?.[data.idCampoJson] || {}}
                    onChange={handleAnalysisChange}
                    erro={Boolean(errosAnalise?.[data.idCampoJson])}
                    disabled={
                      analiseBloqueada ||
                      !titulosSomenteAnalista.includes(data.title) &&
                      !teveAdequacaoRealizada
                    }
                  />
                ) : (
                  <div className="alert alert-warning mt-3" role="alert">
                    O sindicato ainda não enviou a adequação para este campo.
                  </div>
                )}
              </>
            )}

            {!deveMostrarHistorico && (
              <AnalysisField
                idCampo={data.idCampoJson}
                initialValue={analysisValues?.[data.idCampoJson] || {}}
                onChange={handleAnalysisChange}
                erro={Boolean(errosAnalise?.[data.idCampoJson])}
                disabled={analiseBloqueada}
              />
            )}
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default TopicAnalysis;
